import React from 'react';
import styled from 'styled-components';

import { Formatted, Heading } from '@agilytics/components';

const PromoContainer = styled.section`
  display: flex;
  margin: 0 ${({ theme: { spacingTriple } }) => spacingTriple};
  flex-direction: ${({ direction }) => (direction === 'right' ? 'row-reverse' : 'row')};
`;

const PromoImage = styled.img`
  max-width: 100%;
`;

const PromoAside = styled.aside`
  width: ${({ imageSize }) => imageSize || '25%'};
  margin-right: ${({ theme: { spacingTriple } }) => spacingTriple};
`;

const PromoInner = styled.article`
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: center;
`;

export default function Promo({ title, image, direction, imageSize, content }) {
  return (
    <PromoContainer direction={direction}>
      <PromoAside imageSize={imageSize}>
        <PromoImage src={image} />
      </PromoAside>
      <PromoInner>
        <Heading level={2}>{title}</Heading>
        <Formatted content={content} />
      </PromoInner>
    </PromoContainer>
  );
}
